<template>

  <b-modal
    :id="'index-devis-modal-' + this.operationConstruction.id"
    :ok-title="$t('Add')"
    :title="$t('Devis') + ' : ' + operationConstructionName"
    ok-variant="primary"
    ok-only
    centered
    @ok="handleAdd">

    <template v-for="(item, index) in operationConstruction.devis">
      <div class="row mr-1 ml-1">
        <b-link v-on:click="editDevis(index)" class="underline-text"><b>{{ item.artisan.toString }}</b><span v-if="item.numero"> - N°{{ item.numero }}</span></b-link>
        <div class="ml-auto">
          {{ item.prixTTC }}€ TTC
        </div>
      </div>
      <div class="row mr-1 ml-1">
        <div v-if="item.documents && item.documents.length === 1">
          {{ item.documents.length }} {{ $t("document.associe") }}
        </div>
        <div v-if="item.documents && item.documents.length > 1">
          {{ item.documents.length }} {{ $t("document.associes") }}
        </div>
        <div v-if="item.validated" class="ml-auto validated">
          {{ $t("devis.validated") }}
        </div>
      </div>
      <hr class="devis-hr"/>
    </template>

  </b-modal>

</template>

<script>

import AutoCompleteObjectField from "../../../components/b122/editFields/AutoCompleteObjectField.vue";

export default {

  name: "IndexDevisModal",

  components: {
    AutoCompleteObjectField
  },

  props: {
    operationConstructionName: "",
    operationConstruction: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
    }
  },

  emits: ['didAddDevis', 'didEditDevis'],

  async mounted() {
  },

  methods: {

    handleAdd() {
      this.$emit('didAddDevis')
      this.hideModal()
    },

    editDevis(index) {
      this.$emit('didEditDevis', index)
      this.hideModal()
    },

    hideModal() {
      this.$bvModal.hide('index-devis-modal')
    },
  }

}

</script>

<style scoped>
.devis-hr {
  border-top: 2px solid #E0E0E0;
}

.validated {
  color: var(--main-green);
}
</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/IndexDevisModal.vue